module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Name, texts, media, tags, prices, shipping points and all other product details are maintained on the product.":"Name, Texte, Medien, Tags, Preise, Versandpunkte und alle weiteren Produktangaben werden am Produkt gepflegt.","Go to the product":"Zum Produkt"}}')
  delete Component.options._Ctor
}
